import { render, staticRenderFns } from "./EndOfDifficulty.vue?vue&type=template&id=080e17e0&scoped=true&"
import script from "./EndOfDifficulty.vue?vue&type=script&lang=js&"
export * from "./EndOfDifficulty.vue?vue&type=script&lang=js&"
import style0 from "./EndOfDifficulty.vue?vue&type=style&index=0&id=080e17e0&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "080e17e0",
  null
  
)

export default component.exports